/*
 * shopit-api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.41
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The RegisterOrderRequestCartShippingAddress model module.
 * @module model/RegisterOrderRequestCartShippingAddress
 * @version v1
 */
export class RegisterOrderRequestCartShippingAddress {
  /**
   * Constructs a new <code>RegisterOrderRequestCartShippingAddress</code>.
   * @alias module:model/RegisterOrderRequestCartShippingAddress
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>RegisterOrderRequestCartShippingAddress</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/RegisterOrderRequestCartShippingAddress} obj Optional instance to populate.
   * @return {module:model/RegisterOrderRequestCartShippingAddress} The populated <code>RegisterOrderRequestCartShippingAddress</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new RegisterOrderRequestCartShippingAddress();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('formatted'))
        obj.formatted = ApiClient.convertToType(data['formatted'], 'String');
      if (data.hasOwnProperty('latitude'))
        obj.latitude = ApiClient.convertToType(data['latitude'], 'String');
      if (data.hasOwnProperty('longitude'))
        obj.longitude = ApiClient.convertToType(data['longitude'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} id
 */
RegisterOrderRequestCartShippingAddress.prototype.id = undefined;

/**
 * @member {String} formatted
 */
RegisterOrderRequestCartShippingAddress.prototype.formatted = undefined;

/**
 * @member {String} latitude
 */
RegisterOrderRequestCartShippingAddress.prototype.latitude = undefined;

/**
 * @member {String} longitude
 */
RegisterOrderRequestCartShippingAddress.prototype.longitude = undefined;

